import { generateGiftCardCode } from './generateGiftCardCode';
export const generateGiftCardCodes = (quantity, prefix) => {
    const codes = [];
    while (codes.length < quantity) {
        const code = generateGiftCardCode(prefix);
        if (codes.indexOf(code) === -1) {
            codes.push(code);
        }
    }
    return codes;
};
